export default "__VITE_PUBLIC_ASSET__97f03778__"